/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Total AI token usage count
 * @export
 * @interface GetTotalAiTokenUsageResponse
 */
export interface GetTotalAiTokenUsageResponse {
    /**
     * 
     * @type {number}
     * @memberof GetTotalAiTokenUsageResponse
     */
    total: number;
}

/**
 * Check if a given object implements the GetTotalAiTokenUsageResponse interface.
 */
export function instanceOfGetTotalAiTokenUsageResponse(value: object): value is GetTotalAiTokenUsageResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function GetTotalAiTokenUsageResponseFromJSON(json: any): GetTotalAiTokenUsageResponse {
    return GetTotalAiTokenUsageResponseFromJSONTyped(json, false);
}

export function GetTotalAiTokenUsageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTotalAiTokenUsageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
    };
}

export function GetTotalAiTokenUsageResponseToJSON(json: any): GetTotalAiTokenUsageResponse {
    return GetTotalAiTokenUsageResponseToJSONTyped(json, false);
}

export function GetTotalAiTokenUsageResponseToJSONTyped(value?: GetTotalAiTokenUsageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
    };
}

